import { extensions } from '../../extensions/Extensions.mjs';
import { TilingSpritePipe } from './TilingSpritePipe.mjs';

"use strict";
extensions.add(TilingSpritePipe);
//# sourceMappingURL=init.mjs.map
